import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import AssociationSingleDropDownViewModelType from '@/ViewModels/Controls/AssociationSingleDropDownViewModel';
import DropDownListType from '@/Controls/DropDownList';
import LinkType from '@/Controls/Link';

export default class AssociationSingleDropDown extends Control {

    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');
    private Link = ComponentManager.getControl<typeof LinkType>('Link');

    private jQueryControl: JQuery;
    public dropDownList: DropDownListType;
    public linkCreate: LinkType;
    public linkEdit: LinkType;
    public linkDisconnect: LinkType;
    public linkDelete: LinkType;

    public constructor(private viewModel: AssociationSingleDropDownViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'associationsingledropdown',
            technicalName: this.viewModel.technicalName,
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];
                    if (this.viewModel.isRequired() === true) states.push('required');
                    if (this.viewModel.isValid() === true) states.push('valid');
                    if (this.viewModel.isValid() !== true) states.push('invalid');
                    if (this.viewModel.isEnabled() === true) states.push('enabled');
                    if (this.viewModel.isEnabled() !== true) states.push('disabled');

                    return states;
                }
            })
        });

        if (this.viewModel.dropDownList != null) {
            this.dropDownList = new this.DropDownList(this.viewModel.dropDownList);
            let tuple = this.dropDownList.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkCreate != null) {
            this.linkCreate = new this.Link(this.viewModel.linkCreate);
            let tuple = this.linkCreate.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkEdit != null) {
            this.linkEdit = new this.Link(this.viewModel.linkEdit);
            let tuple = this.linkEdit.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkDisconnect != null) {
            this.linkDisconnect = new this.Link(this.viewModel.linkDisconnect);
            let tuple = this.linkDisconnect.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkDelete != null) {
            this.linkDelete = new this.Link(this.viewModel.linkDelete);
            let tuple = this.linkDelete.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }

    public addLabelReference(label: JQuery): JQuery {
        return this.dropDownList.addLabelReference(label);
    }
}

ComponentManager.setControl('AssociationSingleDropDown', AssociationSingleDropDown, 'RADPresentation.HTMLClient.DefaultViewExtensions');